import {MAT_SNACK_BAR_DATA, MatSnackBarRef, SimpleSnackBar,} from '@angular/material/snack-bar';
import {Component, Inject} from '@angular/core';

@Component({
  selector: 'rn-snackbar-notification',
  template: `
    <div class="notification-bar-message">
      @if (data.type === 'error') {
        <span class="notification-icon ri-error-warning-fill"></span>
      }
      @if (data.type === 'info') {
        <span class="notification-icon ri-information-fill"></span>
      }
      @if (data.type === 'success') {
        <span class="notification-icon ri-checkbox-circle-fill"></span>
      }
      @if (data.type === 'warn') {
        <span class="notification-icon ri-error-warning-fill"></span>
      }
      <span>{{ data.message }}</span>
      <div class="spacer"></div>
      @if (data.action) {
        <mat-button class="action-button pointer" (click)="snackBarRef.dismissWithAction()">{{ data.action }}</mat-button>
      }
      @if (!data.action) {
        <span class="notification-icon ri-close-fill" (click)="snackBarRef.dismiss()"></span>
      }
    </div>
  `,
  styles: `
      .notification-bar-message {
          color: white;
          display: flex;
          align-items: center;
      }

      .notification-bar-message > span {
          padding-left: 25px;
      }

      .notification-bar-message > span.ri-close-fill {
          padding-right: 20px;
      }

      .notification-bar-message > .notification-icon {
          font-size: 24px;
      }

      .action-button {
          margin: 0 25px;
      }
  `,
  standalone: false
})
export class SnackbarNotificationComponent extends SimpleSnackBar {

  constructor(public snackBarRef: MatSnackBarRef<SimpleSnackBar>,
              @Inject(MAT_SNACK_BAR_DATA) public data: any) {
    super(snackBarRef, data);
  }
}
